import { reducerWithInitialState } from "typescript-fsa-reducers";

import withImmer from "../../lib/withImmer";
import { EntityValidationResultMap, EntityValidationMapError } from "../../lib/entities/validation";

import {
  bootstrapCompanyShow,
  loadCompanyShow,
  draftCompanyValuesUpdated,
  saveDraftCompanyValues,
  loadInvisibleCompanyValues,
  draftReset,
} from "../actions";
import { CompanyShowResponse, CompanyMembershipSection, FeaturedProject, PortfolioProject, CompanyValue } from "../api";

export interface ShowState {
  companyMembershipSections: CompanyMembershipSection[];
  projects: FeaturedProject[];
  portfolioProjects: PortfolioProject[];
  companyValues: CompanyValue[];
  isLoaded: boolean;
  draftCompanyValues: CompanyValue[];
  draftCompanyValueErrors: EntityValidationResultMap<CompanyValue>;
  isDraftCompanyValuesDirty: boolean;
}

const InitialState: ShowState = {
  companyMembershipSections: [],
  projects: [],
  portfolioProjects: [],
  companyValues: [],
  isLoaded: false,
  draftCompanyValues: [],
  draftCompanyValueErrors: {},
  isDraftCompanyValuesDirty: false,
};

function initState(state: ShowState, result: CompanyShowResponse): ShowState {
  Object.assign(
    state,
    {
      companyMembershipSections: result.company_membership_sections,
      projects: result.projects,
      portfolioProjects: result.portfolio_projects,
      companyValues: result.company_values,
      isLoaded: true,
      isDraftCompanyValuesDirty: false,
    },
    updateDraftCompanyValues(result.company_values)
  );
  return state;
}

function updateDraftCompanyValues(companyValues: CompanyValue[]) {
  const draftCompanyValueErrors: EntityValidationResultMap<CompanyValue> = {};
  return { draftCompanyValues: companyValues, draftCompanyValueErrors };
}

const showReducer = withImmer(reducerWithInitialState<ShowState>(InitialState))
  .case(bootstrapCompanyShow, initState)
  .case(loadCompanyShow.done, (state, { result: actionRes }) => {
    return initState(state, actionRes);
  })
  .case(draftReset, state => {
    Object.assign(state, updateDraftCompanyValues(state.companyValues));
    state.isDraftCompanyValuesDirty = false;
    return state;
  })
  .case(draftCompanyValuesUpdated, (state, { companyValues }) => {
    state.draftCompanyValues = companyValues;
    state.isDraftCompanyValuesDirty = true;
    return state;
  })
  .case(loadInvisibleCompanyValues.done, (state, { result }) => {
    Object.assign(state, updateDraftCompanyValues(result));
    return state;
  })
  .case(saveDraftCompanyValues.done, (state, { result }) => {
    state.isDraftCompanyValuesDirty = false;
    Object.assign(state, updateDraftCompanyValues(result));
    return state;
  })
  .case(saveDraftCompanyValues.failed, (state, { error }) => {
    if (error instanceof EntityValidationMapError) {
      state.draftCompanyValueErrors = error.getResult();
    }
    return state;
  });

export default showReducer;



// WEBPACK FOOTER //
// ./frontend/src/companies/reducers/show.ts